import { createContext, useContext, useState } from "react";

const PropertyContext = createContext();

export const PropertyProvider = ({ children }) => {
 const [selectedProperty, setSelectedProperty] = useState(() => {
    const stored = localStorage.getItem("selectedProperty");
    return stored ? JSON.parse(stored) : null;
  });

  const updateSelectedProperty = (property) => {
    localStorage.setItem("selectedProperty", JSON.stringify(property));
    setSelectedProperty(property);
  };

  return (
    <PropertyContext.Provider value={{  selectedProperty, setSelectedProperty: updateSelectedProperty }}>
      {children}
    </PropertyContext.Provider>
  );
};

export const useProperty = () => useContext(PropertyContext);
